import { Toast } from "@capacitor/toast";
import { IonAlert, IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';
import { appsOutline, homeOutline, navigateOutline, personOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { Redirect, Route, RouteComponentProps, useHistory } from 'react-router-dom';
import { requestService, usuarioAtualizarChaveContato } from '../../../Utils/Services';
import { MessageContext } from '../../../contexts/MessageContext';
import './Home.css';
import Acompanhar from './pages/Acompanhar/Acompanhar';
import Agendamentos from './pages/Agendamentos/Agendamentos';
import AgendamentosDetalhes from './pages/AgendamentosDetalhes/AgendamentosDetalhes';
import Compartilhados from './pages/Compartilhados/Compartilhados';
import Conta from './pages/Conta/Conta';
import ContaAlt from './pages/ContaAlt/ContaAlt';
import Inicio from "./pages/Inicio/Inicio";
import Mensagem from './pages/Mensagem/Mensagem';
import Notificacoes from './pages/Notificacoes/Notificacoes';
import Operacoes from './pages/Operacoes/Operacoes';
import OperacoesAvaliar from './pages/OperacoesAvaliar/OperacoesAvaliar';
import Ordens from './pages/Ordens/Ordens';
import OrdensAgendamentos from './pages/OrdensAgendamentos/OrdensAgendamentos';
import OrdensAvaliar from './pages/OrdensAvaliar/OrdensAvaliar';
import OrdensDetalhes from './pages/OrdensDetalhes/OrdensDetalhes';
import OrdensOperacoes from './pages/OrdensOperacoes/OrdensOperacoes';
import OrdensWorkflow from './pages/OrdensWorkflow/OrdensWorkflow';
import Galeria from './pages/Portfolio/Galeria';
import GaleriaFoco from './pages/Portfolio/GaleriaFoco';
import Portfolio from './pages/Portfolio/Portfolio';
import Roteiro from "./pages/Roteiro/Roteiro";
import Sobre from './pages/Sobre/Sobre';
import TermosPolitica from './pages/TermosPolitica/TermosPolitica';

const Home: React.FC<RouteComponentProps> = ({ match }) => {

  const [showToastNotification, setShowToastNotification] = useState(false);
  const history = useHistory();

  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  const { pkCliente, setPkCliente } = useContext(MessageContext);


  useEffect(() => {
    let pk = (window.localStorage.getItem("perfil") || "") + (window.localStorage.getItem("marca") || "") + "#" + (window.localStorage.getItem("telefone") || "");
    setPkCliente(pk);
  }, []);


  useEffect(() => {
    document.getElementsByTagName("ion-tab-bar")[0].style.display = esconderMenu ? "none" : "flex";
  }, [esconderMenu]);

  /*
  useIonViewDidEnter(() => {

    let temWatch = window.localStorage.getItem("watch");

    console.log("temwatch:"+temWatch);
    if (!temWatch) {
      console.log("entrou");
      navigator.geolocation.getCurrentPosition(
        (result) => {
          console.log("deu result");
          window.localStorage.setItem("latitude", result.coords.latitude.toString());
          window.localStorage.setItem("longitude", result.coords.longitude.toString());
        },
        (rejected) => {
          console.log("nao deu result");
          setShowToastNotification(true);
          //Toast.show({ text: "Ative seu GPS", duration: "long", position: "center" })
        },
        {
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: 5000
        }
      );
    }
  });
  */

  const atualizarChaveContato = async (token: any) => {
    console.log('--token--');
    console.log(token);
    requestService(usuarioAtualizarChaveContato.url, {
      method: usuarioAtualizarChaveContato.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify({
        "chaveContato": token.toString()
      }),
      credentials: 'include'
    },
      history,
      (response: any) => {
        window.localStorage.setItem("chaveContato", token.toString());
      },
      (error: any) => {
        //todo: verificar para tratar caso ocorra erro
        console.log(error);
      });
  }


  // const register = () => {
  //   console.log('Initializing HomePage');

  //   // Register with Apple / Google to receive push via APNS/FCM
  //   PushNotifications.register();

  //   // On success, we should be able to receive notifications
  //   PushNotifications.addListener('registration',
  //     (token: Token) => {
  //       window.localStorage.setItem("chaveContato", token.value.toString());
  //       // if (window.localStorage.getItem("chaveContato") != token.value.toString())
  //       //   atualizarChaveContato(token.value.toString());
  //     }
  //   );

  //   // Some issue with our setup and push will not work
  //   PushNotifications.addListener('registrationError',
  //     (error: any) => {
  //       alert('Error on registration: ' + JSON.stringify(error));
  //     }
  //   );

  //   // Show us the notification payload if the app is open on our device
  //   PushNotifications.addListener('pushNotificationReceived',
  //     async (notification: PushNotificationSchema) => {
  //       setnotifications(notifications => [...notifications, { id: notification.id, title: notification.title, body: notification.body, type: 'foreground' }])

  //       console.log('Push received: ' + JSON.stringify(notification));
  //       const randomId = Math.floor(Math.random() * 10000) + 1;
  //       setShowToast2(true);
  //       await LocalNotifications.schedule({
  //         notifications: [
  //           {
  //             title: notification.title || '',
  //             body: notification.body || '',
  //             id: randomId,
  //             extra: {
  //               notification: notification
  //             }
  //           }
  //         ]
  //       });

  //     }
  //   );

  //   // Method called when tapping on a notification
  //   PushNotifications.addListener('pushNotificationActionPerformed',
  //     (notification: ActionPerformed) => {
  //       setnotifications(notifications => [...notifications, { id: notification.notification.data.id, title: notification.notification.data.title, body: notification.notification.data.body, type: 'action' }])
  //     }
  //   );
  // }


  const showToast = async (msg: string) => {
    await Toast.show({
      text: msg
    })
  }

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route path={`${match.url}/inicio`} component={Inicio} exact />
        <Route path={`${match.url}/roteiro`} component={Roteiro} exact />

        <Route path={`${match.url}/operacoes`} component={Operacoes} exact />
        <Route path={`${match.url}/operacoes/acompanhar`} component={Acompanhar} exact />
        <Route path={`${match.url}/operacoes/operacoesavaliar`} component={OperacoesAvaliar} exact />

        <Route path={`${match.url}/agendamentos`} component={Agendamentos} exact />
        <Route path={`${match.url}/agendamentos/agendamentosdetalhes`} component={AgendamentosDetalhes} exact />

        <Route path={`${match.url}/ordens`} component={Ordens} exact />
        <Route path={`${match.url}/compartilhados`} component={Compartilhados} exact />
        <Route path={`${match.url}/notificacoes`} component={Notificacoes} exact />
        <Route path={`${match.url}/ordens/mensagem`} component={Mensagem} exact />
        <Route path={`${match.url}/ordens/ordensWorkflow`} component={OrdensWorkflow} exact />
        <Route path={`${match.url}/ordens/ordensdetalhes`} component={OrdensDetalhes} exact />
        <Route path={`${match.url}/ordens/ordensagendamentos`} component={OrdensAgendamentos} exact />
        <Route path={`${match.url}/ordens/ordensoperacoes`} component={OrdensOperacoes} exact />
        <Route path={`${match.url}/ordens/ordensavaliar`} component={OrdensAvaliar} exact />

        <Route path={`${match.url}/portfolio`} component={Portfolio} exact />
        <Route path={`${match.url}/galeria`} component={Galeria} exact />
        <Route path={`${match.url}/galeriafoco`} component={GaleriaFoco} exact />

        <Route path={`${match.url}/conta`} component={Conta} exact />
        <Route path={`${match.url}/contaalt`} component={ContaAlt} exact />
        <Route path={`${match.url}/termospolitica`} component={TermosPolitica} exact />
        <Route path={`${match.url}/sobre`} component={Sobre} exact />
        <Route exact path={match.url} render={() => <Redirect to={`${match.url}/ordens`} />} />
      </IonRouterOutlet>

      {(window.localStorage.getItem("loja")) ? (

        <IonTabBar slot="bottom" style={{ shadowBox: "0px 0px 5px black" }}>

          <IonTabButton href={`${match.url}/portfolio`} tab="portfolio">
            <IonIcon icon={homeOutline}></IonIcon>
            <IonLabel>Início</IonLabel>
          </IonTabButton>
          <IonTabButton href={`${match.url}/ordens`} tab="ordens">
            <IonIcon icon={appsOutline}></IonIcon>
            <IonLabel>{window.localStorage.getItem("servicoTipoPlural") || "Ordens"}</IonLabel>
          </IonTabButton>
          <IonTabButton href={`${match.url}/roteiro`} tab="roteiro">
            <IonIcon icon={navigateOutline}></IonIcon>
            <IonLabel>Lojas</IonLabel>
          </IonTabButton>
          <IonTabButton href={`${match.url}/conta`} tab="conta">
            <IonIcon icon={personOutline}></IonIcon>
            <IonLabel>Conta</IonLabel>
            <IonAlert
              isOpen={showToastNotification}
              onDidDismiss={() => setShowToastNotification(false)}
              cssClass='my-custom-class'
              header={'Aviso!'}
              subHeader={'Habilite seu GPS'}
              message={'Para encontrar a loja você precisa habilitar seu GPS.'}
              buttons={['OK']}
              backdropDismiss={false}
            />

          </IonTabButton>
        </IonTabBar>

      ) : (
        <IonTabBar slot="bottom" style={{ shadowBox: "0px 0px 5px black" }}>

          <IonTabButton href={`${match.url}/inicio`} tab="inicio">
            <IonIcon icon={homeOutline}></IonIcon>
            <IonLabel>Início</IonLabel>
          </IonTabButton>
          <IonTabButton href={`${match.url}/ordens`} tab="ordens">
            <IonIcon icon={appsOutline}></IonIcon>
            <IonLabel>Pedidos</IonLabel>
          </IonTabButton>
          {/* <IonTabButton href={`${match.url}/roteiro`} tab="roteiro">
            <IonIcon icon={navigateOutline}></IonIcon>
            <IonLabel>Parceiros</IonLabel>
          </IonTabButton> */}
          <IonTabButton href={`${match.url}/conta`} tab="conta">
            <IonIcon icon={personOutline}></IonIcon>
            <IonLabel>Conta</IonLabel>
            <IonAlert
              isOpen={showToastNotification}
              onDidDismiss={() => setShowToastNotification(false)}
              cssClass='my-custom-class'
              header={'Aviso!'}
              subHeader={'Habilite seu GPS'}
              message={'Para encontrar a loja você precisa habilitar seu GPS.'}
              buttons={['OK']}
              backdropDismiss={false}
            />

          </IonTabButton>
        </IonTabBar>
      )}

    </IonTabs>
  );
};

export default Home;

